import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-stepper-component',
  templateUrl: './shared.stepper.component.html',
  styleUrls: ['./shared.stepper.component.scss']
})
export class SharedStepperComponent {

    public _steps: number[];//llista de passos
    @Input()
    public get steps(): number[] {
      return this._steps;
    }
    public set steps(value: number[]) {
      if (this._steps === value)
        return;
      this._steps = value;
    }

    public _currentStep: number;// pas actiu
    @Input()
    public get currentStep(): number {
      return this._currentStep;
    }
    public set currentStep(value: number) {
      if (this._currentStep === value)
        return;
      this._currentStep = value;
    }
}